import './logrocket';
import './sentry';
import './App.css';

import { OAuthConfiguration } from './oauth/oauthConfiguration';

import { OAuthClient } from './oauth/oauthClient';
import { lighten } from '@mui/material/styles';
import { Provider, connect } from 'redux-bundler-react';
import React from 'react';
import ManeAuth from '../models/mane_auth';
import AuthenticationCheck from './atoms/AuthenticationCheck';
import Layout from './Layout';
import PusherContainer from './atoms/PusherContainer';
import { AuthProvider } from 'oidc-react';
import store from './store';

import {
  createMuiTheme,
  createTheme,
  ThemeProvider,
  useMediaQuery,
} from '@mui/material';
import theme from './theme';

console.log('Loading version: ', process.env.REACT_APP_COMMIT_REF);
const ConnectedApp = connect(
  'selectRoute',
  'doFetchAuthenticatedUser',
  'doConfigureMiddleware',
  'doUpdateUrl',
  'selectForcedLogout',
  'selectThemeSetting',
  ({
    route: {
      component: PageComponent,
      options: { requireAuth = true },
    },
    doUpdateUrl,
    doFetchAuthenticatedUser,
    doConfigureMiddleware,
    forcedLogout,
    themeSetting,
  }) => {
    const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');

    const getPaletteType = () => {
      if (themeSetting === 'system') {
        return prefersDarkMode ? 'dark' : 'light';
      } else {
        return themeSetting || 'light';
      }
    };

    const currentTheme = React.useMemo(
      () => createTheme(theme(getPaletteType)),
      [themeSetting, prefersDarkMode],
    );

    doConfigureMiddleware();
    const [state, setState] = React.useState({
      isLoaded: false,
      isLoggedIn: false,
      sessionExpired: false,
      oauthClient: new OAuthClient({
        tokenHandlerBaseUrl: process.env.REACT_APP_TOKEN_HANDLER_BASE_URL,
      }),
    });

    // This only runs once to initialize the app
    React.useEffect(() => {
      startup();
      // return () => cleanup();
    }, []);

    /*
     * Create global objects when the app loads
     */
    async function startup() {
      // const storage = new StorageHelper(() => multiTabLogout());
      // await props.viewModel.initialize(storage);
      // window.addEventListener('storage', storage.onChange);

      ManeAuth.setOauthClient(state.oauthClient);
      setState(prevState => ({
        ...prevState,
        isLoaded: false,
        isLoggedIn: false,
        sessionExpired: false,
      }));
    }

    /*
     * Called back from the page load view
     */
    function setIsLoaded() {
      setState(prevState => {
        return {
          ...prevState,
          isLoaded: true,
        };
      });
    }

    /*
     * Called back from the start authentication view
     */
    function setIsLoggedIn() {
      // props.viewModel.storage!.setLoggedOut(false);
      //
      doFetchAuthenticatedUser();
      setState(prevState => {
        return {
          ...prevState,
          isLoggedIn: true,
          sessionExpired: false,
        };
      });
    }

    /*
     * Called back from the start authentication view
     */
    function setExpiresAt(expiresAt) {
      // props.viewModel.storage!.setLoggedOut(false);
      ManeAuth.setExpiresAt(expiresAt);
      setState(prevState => {
        return {
          ...prevState,
          expiresAt: expiresAt,
        };
      });
    }
    // const oidcConfig = {
    //   onSignIn: async (user: any) => {
    //     console.log(user);

    //     ManeAuth.setCurrentUser(user);
    //     doUpdateUrl('/');
    //   },
    //   automaticSilentRenew: true,
    //   authority: 'https://app.local.com:4444',
    //   clientId: 'auth-code-client-mane',
    //   responseType: 'code',
    //   redirectUri: 'https://app.local.com:3000/',

    //   scope: 'openid offline_access',
    // };
    return requireAuth ? (
      // <AuthProvider {...oidcConfig}>
      <ThemeProvider theme={currentTheme}>
        <AuthenticationCheck
          oauthClient={state.oauthClient}
          sessionExpired={state.sessionExpired}
          isLoggedIn={state.isLoggedIn}
          setIsLoaded={setIsLoaded}
          setIsLoggedIn={setIsLoggedIn}
          setExpiresAt={setExpiresAt}
        >
          {/* eslint-disable-next-line no-unused-vars */}
          {user => (
            <PusherContainer>
              <Layout />
            </PusherContainer>
          )}
        </AuthenticationCheck>
      </ThemeProvider>
    ) : (
      // </AuthProvider>
      // <PusherContainer>
      <ThemeProvider theme={currentTheme}>
        <PageComponent />
      </ThemeProvider>
      // </PusherContainer>
    );
  },
);

const App = () => {
  return (
    <Provider store={store}>
      <ConnectedApp />
    </Provider>
  );
};

export default App;
